import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdiantamentoDetalharComponent } from './adiantamento-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: AdiantamentoDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class AdiantamentoDetalharRoutingModule { }
